import * as React from 'react';

/**
 * Возвращает `ref` который можно навесить на элемент и получить аналогичное `useEffect` поведение
 *
 * Вызывается при изменении значения `ref`
 * Не вызывается при размонтировании, или если значение `ref` приводится к `false`
 * Для этого используйте возвращаемую эффектом функцию (подобно тому как это работает в `useEffect`)
 *
 * Если зависимости не переданы, то эффект вызывается только когда изменяется значение `ref`
 * При изменении зависимостей обновляется возвращаемый хуком `ref`-колбэк,
 * поэтому эффект будет вызван повторно если он проброшен на `React`-элемент
 *
 * Рекомендуется использовать этот хук только для `ref` на `React`-элементы
 *
 * Если на элемент нужно повесить более одного `ref`, то рекомендуется возпользоваться хуком `useForkRef`
 *
 * @export
 * @template T
 * @param {TRefEffect<T>} effect
 * @param {React.DependencyList} [deps=[]]
 * @returns {React.RefCallback<T>}
 */
export function useEffectRef(effect) {
  var deps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var cleanup = React.useRef();
  return React.useCallback(function (node) {
    if (cleanup.current) {
      (void 0, cleanup.current)();
      cleanup.current = undefined;
    }

    if (node) {
      cleanup.current = effect(node);
    }
  }, deps);
}